import React, { useEffect, useState } from 'react';
import {Table, Container, Button} from 'react-bootstrap';
import classes from '../../WebsiteManagement/websiteManagement.module.css';
import Page from '../../pagination/pagination';
import { GetItinerary } from '../../../entities/action/action';

const ItineraryList = (props)=>{
    const [dataSet,updateDataSet] = useState([]);
    const [count,updateCount] = useState(0)
    const postPerPage = 20;
    const [currentPage,updateCurrentPage] = useState(1);
    const indexOfLast = currentPage*postPerPage;
    const indexOfFirst = indexOfLast - postPerPage;
    const currentPosts = dataSet.slice(indexOfFirst,indexOfLast);
    const handleChangePage = (event,value)=>{
        updateCurrentPage(value)
    }
    useEffect(()=>{
        updateCount(Math.ceil(dataSet.length/postPerPage))
    },[dataSet])

    useEffect(() => {
            (async () => {
              let arr = await GetItinerary();
              if (arr?.success) {
                updateDataSet(arr?.itineraries);
              }
            })();
          }, []);

    const setStatus = async(status, id) => {
        const token = localStorage.getItem('token');
        const authHeader = `Bearer ${token}`
        const res = await fetch(`https://api.zupptravel.com/api/v1/itinerary/get/${id}/${status}`, {
            method: "get",
            headers: {
            "Content-Type": "application/json",
            'Authorization': authHeader
            }
        });

        const json = await res.json();

        if (json?.success) {
            alert("Updated Status Successfully!");
            window.location.reload();
        } else {
            alert("Error! Please try again later");
        }
    }
 
    return(
        <Container fluid style={{padding:'0'}}>
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Holiday ID</th>
                        <th>Days</th>
                        <th>Holiday Name</th>
                        <th>Flights</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        currentPosts.length>0?currentPosts.map((data,key)=>
                            <tr key={key}>
                                <td>{key+1}</td>
                                <td>{data.holidayId}</td>
                                <td>{data.day}</td>
                                <td>{data.holidayName}</td>
                                <td>
                                    {data.flightsIncluded === true
                                        ? `Included${data.flightsNote ? ` — ${data.flightsNote}` : ''}`
                                        : data.flightsIncluded === false
                                        ? `Not included${data.flightsNote ? ` — ${data.flightsNote}` : ''}`
                                        : '—'}
                                </td>
                                <td className={classes.CenterRow}>
                                    {data.isActive ?
                                        <Button variant="success" onClick={()=>setStatus(false,data?.id)}>Active</Button>:
                                        <Button variant="danger" onClick={()=>setStatus(true,data?.id)}>Inactive</Button>
                                    }
                                </td>
                            </tr>
                        ):null
                    }
                </tbody>
            </Table>
            <div style={{display:'flex',justifyContent:'center',margin:'15px 0'}}>
                <Page count={count} change={handleChangePage} page={currentPage}/> 
            </div>
        </Container>
    )
}
export default ItineraryList;